<template lang="pug">
.form-group(
    :class=`{
      "form-success--": search,
      "update-button": updateButton,
      "symbol list": symbol,
      "readonly": disabled,
      "right-label": rightLabel
    }`
    @mousedown='emitMousedown'
  )
  v-money.hide(v-if='type === "money"' :supplementalPrecision='supplementalPrecision' ref='money') {{ setValue }}
  v-money.hide(v-if='type === "money"' :supplementalPrecision='supplementalPrecision' ref='moneyPlaceholder') 0
  ed-input-tooltip(v-if='(helptipBody || $slots.message) && focused || (helptipBody || $slots.message) && error'
                  :class='{ "error-message": error }'
                  :helptipHeader='helptipHeader'
                  :errorTip='error'
                  :altTip='$attrs["info-only"]'
                  :helptipBody='$slots.message ? "" : helptipBody'
                  :v-align='typeof $attrs["info-only"] === "undefined"'
                )
    slot(name='message' slot='message')
  label(v-if='fieldLabel') {{ fieldLabel }}
    em.optional(v-if='!required && !hideOptional') &nbsp;- optional
  label(v-if='emptyFieldLabel') &nbsp;
  slot(name='additionalText')
  input.form-control(
    :class=`{
      "form-control-money": type === 'money',
      "money-placeholder": !conditionalText && type === "money",
      "nil": nilMoney,
      "negative": negativeMoney,
      "text-right": symbol || amount && rightLabel,
    }`
    :autofocus='autofocus'
    :dir='setDir'
    :required='required'
    :type='type'
    :value='setValue'
    v-bind='$props'
    v-focus.lazy='autofocus'
    @focus='emitFocus'
    @focusout='emitFocusOut'
    @blur='emitBlur'
    @input='updateInput($event.target.value)'
    @keyup='updateKeyUp($event.target.value)'
    @change='changeValue($event.target.value)'
    ref='input'
    :style='symbolWidth'
    :maxlength='maxlength'
    :placeholder='moneyPlaceholder'
  )
  span.toggle-password-icon(v-if='showPassword' @click='togglePassword')
      i.fal.fa-eye(v-if='fieldType === "password"')
      i.fal.fa-eye-slash(v-if='fieldType === "text"')
  ed-button.btn.btn-actionbar.update-button(v-if='updateButton' :disabled='disabled' @click='emitUpdate') Save
  span.search.search-icon(v-if='search')
    i.fa.fa-search
  span.search.search-icon-right(v-if='searchBox')
    i.fa.fa-search
  span(id='symbolWrapper', ref='symbolWrapper' @click='focusInput').symbol-holder {{ symbol }}
  small.form-text.text-muted(v-if='helpText') {{ helpText }}
</template>

<script>

import VMoney from '@/core/value-objects/money/index.vue'
import EdInputTooltip from '@/core/components/edInputTooltip/index.vue'

let lastValue = ''

export default {
  name: 'ed-input',
  props: {
    currency: String,
    negative: Boolean,
    fieldLabel: String,
    rightLabel: Boolean,
    emptyFieldLabel: Boolean,
    hideOptional: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    maxlength: {
      type: Number,
      default: 255
    },
    dir: String,
    required: Boolean,
    autofocus: Boolean,
    autoselect: Boolean,
    name: String,
    disabled: Boolean,
    error: Boolean,
    placeholder: String,
    conditionalText: String,
    value: [String, Number],
    helpText: String,
    showPassword: Boolean,
    updateButton: Boolean,
    helptipHeader: String,
    helptipBody: String,
    symbol: String,
    search: Boolean,
    searchBox: Boolean,
    amount: { type: Boolean, default: false },
    supplementalPrecision: { type: Number, default: 0 },
    integer: Boolean,
    onlyNumbers: Boolean
  },
  components: {
    'v-money': VMoney,
    'ed-input-tooltip': EdInputTooltip
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        if (binding.value) el.focus()
        else el.blur()
      },
      componentUpdated: function (el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return
          }
        }
        if (binding.value) el.focus()
        else el.blur()
      }
    }
  },
  data () {
    return {
      focused: false,
      fieldType: this.type,
      symbolWidth: '',
      amountValue: utils.copy(this.value || null),
      moneyValue: utils.copy(this.value || 0),
      amountValueWasChanged: false,
      moneyPlaceholder: this.conditionalText || this.placeholder
    }
  },

  created() {
    if (this.amount && this.amountValue) {
      this.formatAmount(this.value)
      this.formatMoney()
    }
    if (this.updateButton) lastValue = lastValue || this.value
  },

  mounted() {
    this.$nextTick(() => {
      this.showMoneyValue()
      this.getSymbolPadding()
      this.$nextTick(() => {
        this.moneyPlaceholder = this.setMoneyPlaceholder()
        this.formatMoney()
      })
    })
  },

  updated() {
    if (!this.moneyPlaceholder) {
      this.moneyPlaceholder = this.setMoneyPlaceholder()
    }

    if (!this.focused && !this.negative) {
      this.formatMoney()
    }
  },

  watch: {
    value (oldV, newV) {
      if (this.amount) {
        if (this.amountValueWasChanged === true) {
          // this.formatAmount(utils.copy(this.value || null))
        } else {
          if (+oldV !== +newV) {
            this.amountValue = this.value
          }
          if (this.type === 'money') {
            this.moneyValue = this.value
          }

          this.focused || this.$nextTick(this.formatMoney)
        }
        this.amountValueWasChanged = false
      }
    },

    currency () {
      // this.formatAmount(utils.copy(this.value || null))
      this.formatMoney()
    },

    conditionalText () {
      this.moneyPlaceholder = this.setMoneyPlaceholder()
      this.formatMoney()
    }
  },

  computed: {
    setDir () {
      if (this.type === 'number' && this.dir !== 'ltr') {
        return 'rtl'
      } else {
        return 'ltr'
      }
    },
    setType () {
      return this.fieldType
    },
    setValue() {
      if (this.conditionalText) {
        return null
      }
      if (this.amount) {
        return this.amountValue
      } else {
        return this.value
      }
    },
    nilMoney() {
      return Math.floor(this.setValue) === 0
    },
    negativeMoney() {
      return this.setValue < 0
    }
  },
  methods: {
    focusInput() {
      this.$refs.input.focus()
    },

    getSymbolPadding () {
      if (this.symbol) {
        var symbolHolder = this.$refs.symbolWrapper.clientWidth + 10
        this.symbolWidth = 'paddingRight: ' + symbolHolder + 'px'
      }
    },

    getDigits() {
      let digits = 2
      if (this.supplementalPrecision === 1) digits = 3
      else if (this.supplementalPrecision === 2) digits = 4
      else if (this.supplementalPrecision === 6) digits = 8
      return digits
    },

    updateInput (value) {
      if (this.onlyNumbers) {
        const onlyNumbers = (value.match(/\d+/g) || []).join('')
        this.$refs.input.value = onlyNumbers
        this.$emit('input', onlyNumbers)
        return
      }
      if (this.integer) {
        this.$refs.input.value |= parseInt(value) || 0
        this.$emit('input', parseInt(value) || 0)
        return
      }
      if (this.updateButton) lastValue = value || lastValue
      if (this.amount) {
        let number = utils.numeric.getNumberFromString(value)
        number = utils.numeric.setMaxNumberOfDigits(number, this.getDigits())
        this.$emit('input', number)
        this.amountValue = number
      } else {
        this.$emit('input', value)
      }
    },

    updateKeyUp (value) {
      if (this.amount) {
        this.amountValue = value
      }
      this.$emit('keyup', value)
    },

    changeValue (value) {
      if (this.amount) {
        let number = utils.numeric.getNumberWithDecimals(value, this.getDigits())
        this.$emit('change', number)
        this.formatAmount(number)
        this.amountValueWasChanged = true
      } else {
        this.$emit('change', value)
      }
    },

    formatAmount(value) {
      value = `${value}` === '-' ? 0 : value
      value = utils.numeric.getNumberWithDecimals(`${value}`, this.getDigits())
      value = value ? parseFloat(value, 10) : 0
      // value = value.toLocaleString(utils.locale.getLang(), {minimumFractionDigits: 2, maximumFractionDigits: 2})
      this.amountValue = value === 0 ? '' : value
    },

    formatMoney() {
      if (this.type === 'money') {
        // value was changed without user input
        if (this.value !== this.amountValue) {
          this.amountValue = this.value
        }

        this.amountValue = this.negative && this.amountValue > 0 ? this.amountValue * -1 : this.amountValue
        this.moneyValue = this.amountValue % 1 === 0 ? +this.amountValue : this.amountValue
        this.$nextTick(() => {
          this.setRefsInputValue()
          this.$nextTick(() => {
            this.setRefsInputValue()
          })
        })
      }
    },

    setRefsInputValue() {
      if (this.$refs.input) {
        this.$refs.input.value = this.conditionalText ? '' : (this.$refs.money && this.$refs.money.formatted.trim())
      }
    },

    showMoneyValue() {
      if (this.type === 'money') {
        this.$refs.input.value = this.negative ? Math.abs(this.moneyValue) : this.moneyValue
      }
    },

    togglePassword () {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password'
      this.$refs.input.setAttribute('type', this.fieldType)
      this.$refs.input.focus()
    },
    emitBlur (event) {
      if (this.updateButton && this.value === '') {
        this.$emit('input', lastValue)
        this.valueData = lastValue
      }
      this.$emit('focus', event.target.value)
      this.focused = false
    },
    emitFocus (event) {
      if (this.amount) {
        // let number = utils.numeric.getNumberWithDecimals(event.target.value)

        // edit money value (unformatted)
        if (this.type === 'money') {
          this.showMoneyValue()
        } else {
          // this.amountValue = number
        }
      }

      if (this.type === 'money' && this.amount && this.amountValue === null) {
        this.showMoneyValue()
      }

      this.$emit('focus', event.target.value)
      this.focused = true
      this.getSymbolPadding()

      if (!+this.amountValue && this.amount) {
        this.$refs.input.value = ''
      }

      if (this.autoselect) {
        this.$nextTick(() => {
          this.$refs.input.setSelectionRange(0, this.$refs.input.value.length)
        })
      }
    },
    emitFocusOut (event) {
      if (this.amount) {
        this.formatAmount(event.target.value)
        this.formatMoney()
      }
      this.$emit('focusout', event.target.value)
    },
    emitUpdate () {
      this.$emit('update')
    },
    emitMousedown (e) {
      this.$emit('mousedown', e)
    },

    setMoneyPlaceholder() {
      return this.conditionalText || this.placeholder || (this.$refs.moneyPlaceholder && this.$refs.moneyPlaceholder.formatted.trim())
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.form-group {
  position: relative;

  em.optional {
    @include optional-label;
  }

  &.right-label {
    label {
      float: right;
      padding-right: 12px;
      line-height: 2em;
      margin-bottom: 0.1rem;
    }
  }
}

// validations
.form-group {
  &.invalid, &.invalid:focus,
  &.has-error, &.has-error:focus {
    .form-control, .form-control:focus {
      border-width: 1px;
      @include theme {
      border-color: v(urgent-01);
      box-shadow: 0px 0px 0px 1px v(urgent-01);
      }
    }
  }
}

.form-group {
  &.loading {
    &:before {
      animation: none;
      font-size: 15px;
      content: '';
      width: calc(100% - 20px);
      height: 20px;
      margin-top: -10px;
      margin-left: 10px;
      left: 0;
      border-radius: 3px;
      @include theme {
        background: v(background-light);
      }
    }
    &.symbol:before {
      margin-top: -1px;
      left: auto;
      width: 67%;
    }
    &:after {
      display: none;
    }
  }
  &.readonly:not(.not-used) {
    .form-control[class] {
      /*background-image: none;
      background-color: transparent;
      border: none;
      box-shadow: none;
      padding: 0;*/
    }
  }
}

// Inline
.form-group.inline {
  display: inline-block;

  + .inline {
    min-width: 234px;
    margin-left: 1em;
    margin-bottom: 0;
  }

  &, > label {
    vertical-align: top;
    font-weight: $font-weight-extra-bold;
  }
}

// Small inline
.form-group.small {
  display: inline-block;
  vertical-align: middle;
  body .theme & {
    margin: 0 2px;
  }
  input {
    height: 1.8em;
    padding: 0 2px;
  }
  &.box {
    input {
      padding: 0 8px;
      @include placeholder {
        font-size: 0.78rem;
      }
    }
  }
}
.form-group.inline:not(.filter-views) {
  display: inline-block;
  white-space: nowrap;
  margin-bottom: 0;
  input {
    display: inline-block;
    height: 1.5rem;
    vertical-align: middle;
    border-radius: 3em;
    width: auto;
  }
  &.small {
    input {
      border-radius: 0;
      @include placeholder {
        text-transform: uppercase;
        font-size: 0.78rem;
        font-weight: 600;
      }
    }
    label {
      font-size: 0.78rem;
      vertical-align: top;
    }
  }
  label {
    display: inline-block;
    margin-left: 4px;
    margin-right: 4px;
  }
  &.compact {
    label {
      display: none;
    }
    input {
      width: 7em;
      text-align: center;
      @include theme {
      border: none;
      }
    }
  }
}

.form-control,
.form-group .form-control {
  @include form-field;
}

.form-control {
  &.nil {
    /*@include theme {
    color: v(background);
    }*/
  }
  &.form-control-money.negative {
    @include theme {
    color: v(urgent-02);
    }
  }
  &.form-control-money {
    @include theme {
    color: v(ink);
    }

    &.money-placeholder {
      text-align: right;
    }
  }
}

// search input
/*.theme.skin */.form-control[search],
.form-group.inline:not(.filter-views) .form-control {
  @include theme {
  background: none;
  border: none;
  box-shadow: none;
  border-bottom: 2px solid v(background);
  &:focus {
    border: none;
    box-shadow: none;
    border-bottom: 2px solid v(tertiary-01);
  }
  }
}
.theme.skin .form-control[search],
.form-group.inline.small .form-control {
  box-shadow: none;
  border-width: 1px;
  @include theme {
  border-color: v(background-light)
  }
  &.dirty, &.dirty:focus {
    border-width: 1px;
    @include theme {
    border-color: v(urgent-01)
    }
  }
  &:focus {
    border-width: 1px;
    @include theme {
    border-color: v(tertiary-01)
    }
  }
}
.theme.skin .search.bar .form-control[search],
.theme.skin .search-box .form-control[search] {
  border: none;
}
.form-group.inline.small.update-button .form-control {
  font-size: $font-size-base;
  font-weight: $font-weight-bold;
  padding-left: 0;
  margin-top: -4px;
  margin-bottom: -1px;
}

/*.theme.skin */.form-control {
  &[search] {
    padding-left: 2em;
  }
  &[searchbox] {
    padding-right: 3em;
    padding-top: 7px;
    text-overflow: ellipsis;
  }
}

.form-control[search],
.form-control[searchbox] {
  & + .search {
    position: absolute;
    cursor: pointer;
    @include theme { color: v(ink-light) }
    &:hover {
      @include theme { color: v(ink) }
    }

    &-icon {
      left: 0.4em;
      bottom: 0.1em;
    }
    &-icon-right {
      padding-left: 0.4em;
      right: 0.5em;
      bottom: 0.3em;
      display: block;
      @include theme {
      border-left: 1px solid v(background);
      }
    }
  }
}

.theme.skin .btn.btn.btn-actionbar.update-button {
  padding: 0 4px;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: -2px;
  position: absolute;
  right: 0.4em;
  bottom: 0.1em;
  @include theme { color: v(ink) }
}

.symbol-holder {
  display: inline-block;
  height: 34px;
  position: absolute;
  right: 2%;
  bottom: 0;
  z-index: 1;
  padding: .5rem .5rem .5rem 0rem;
  font-size: $font-size-small;
  line-height: 1.5;
}

.toggle-password-icon {
  @include theme { color: v(background) }
  display: inline-block;
  height: 100%;
  position: absolute;
  right: 2%;
  top: 40%;
  z-index: 1;
  padding: .5rem;
  transition: all .5s ease-out;

  &:hover {
    cursor: pointer;
    @include theme { color: v(primary-05) }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edInput/index.vue